function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.26 22.1c.155.133.243.33.243.535v5.004c0 .391-.313.708-.698.708a.703.703 0 01-.699-.708v-4.184l-23.446 3.52a.689.689 0 01-.201 0L2.397 24.361v18.588l4.115.595a.706.706 0 01.593.8.7.7 0 01-.79.601L1.6 44.263a.705.705 0 01-.6-.7V23.544c0-.205.088-.4.24-.535a.692.692 0 01.557-.166l18.759 2.715 24.146-3.624c.201-.03.405.03.559.164zm-.455 9.836c.385 0 .698.317.698.708v10.008c0 .351-.254.649-.596.7l-24.247 3.64a.689.689 0 01-.201 0l-9.43-1.364a.706.706 0 01-.592-.801.7.7 0 01.79-.6l9.329 1.35 23.55-3.535v-9.398c0-.391.313-.708.699-.708z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.823 38.772a.706.706 0 01-.589.804l-1.588.238a.7.7 0 01-.794-.596.706.706 0 01.589-.804l1.589-.238a.7.7 0 01.793.596zM37.411 39.353a.707.707 0 01-.576.813l-4.347.722a.7.7 0 01-.802-.584.707.707 0 01.576-.813l4.347-.721a.7.7 0 01.802.583zM20.558 25.567c.386 0 .698.317.698.707v20.018c0 .39-.312.708-.698.708a.703.703 0 01-.699-.708V26.274c0-.39.313-.707.699-.707zM5.29 27.387c.386 0 .699.317.699.708v1.82c0 .39-.313.707-.699.707a.703.703 0 01-.698-.708v-1.82c0-.39.313-.707.698-.707zM5.29 32.846c.386 0 .699.317.699.708v4.55c0 .39-.313.707-.699.707a.703.703 0 01-.698-.708v-4.55c0-.39.313-.707.698-.707zM20.184 1.11a.692.692 0 01.373-.11h15.267a.7.7 0 01.66.477l1.048 3.084a.71.71 0 01-.433.9.696.696 0 01-.888-.44l-.885-2.606H20.759L4.356 12.912l4.39 11.3a.71.71 0 01-.393.918.696.696 0 01-.906-.4L2.845 12.886a.713.713 0 01.276-.858L20.184 1.109z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.796 12.627c0-.391.313-.708.698-.708h15.267c.287 0 .544.177.65.447l1.284 3.287a.71.71 0 01-.392.918.695.695 0 01-.906-.397l-1.11-2.84H3.494a.703.703 0 01-.698-.707zm18.278 5.915a.696.696 0 01.906.397l2.57 6.573a.71.71 0 01-.392.919.696.696 0 01-.907-.398l-2.57-6.573a.71.71 0 01.393-.918z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.22 1.33a.713.713 0 01-.217.976l-16.56 10.601 1.228 3.02a.711.711 0 01-.38.923.695.695 0 01-.912-.385l-1.45-3.57a.713.713 0 01.272-.867L27.257 1.11a.693.693 0 01.964.22zM36.414 1.33a.713.713 0 01-.217.976L19.134 13.225a.693.693 0 01-.963-.22.713.713 0 01.217-.977L35.451 1.11a.693.693 0 01.963.22zM38.618 5.853c-3.858 0-6.985 3.168-6.985 7.077 0 3.908 3.128 7.076 6.985 7.076 3.858 0 6.985-3.168 6.985-7.076 0-3.909-3.127-7.077-6.985-7.077zm-8.382 7.077c0-4.69 3.753-8.493 8.382-8.493C43.248 4.437 47 8.24 47 12.93c0 4.69-3.753 8.492-8.382 8.492s-8.382-3.802-8.382-8.492z",
  fill: "#2D2D2D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.56 20.071a.695.695 0 01.926.346l.655 1.437a.712.712 0 01-.341.94.695.695 0 01-.927-.347l-.655-1.436a.712.712 0 01.342-.94zM43.315 10.318a.714.714 0 01-.023 1l-5.122 4.954a.692.692 0 01-.965 0l-2.561-2.477a.714.714 0 01-.023-1 .692.692 0 01.987-.023l2.08 2.01 4.64-4.487a.692.692 0 01.987.023z",
  fill: "#2D2D2D"
});

function SvgInDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "/img/in-deposit.svg";
export { SvgInDeposit as ReactComponent };